import {COLLECTION_ITEM_TYPES} from './CollectionCortisConstants';
import {
    IMAGE_CORTIS_MEMBER_JAMES,
    IMAGE_CORTIS_MEMBER_JUHOON,
    IMAGE_CORTIS_MEMBER_KEONHO,
    IMAGE_CORTIS_MEMBER_MARTIN,
    IMAGE_CORTIS_MEMBER_SEONGHYEON,
    IMAGE_CORTIS_MEMBERS,
} from '../../library/constants/cortis';

export function getCollectionCortisSections() {
    const header = [
        {
            id: 'title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_TITLE,
            value: {
                name: '있는 그대로.\n꾸미지 않은 청춘.\nCORTIS\n다섯 패션 다섯 취향',
            },
        },
        {
            id: 'subtitle',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SUBTITLE,
            value: '솔직함으로 무장한\nCORTIS의 다섯 색깔',
        },
        {
            id: 'main-image',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBERS,
                aspectRatio: 361 / 241,
                caption: 'The 1st EP [COLOR OUTSIDE THE LINES]',
            },
        },
        {
            id: 'main-quote',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QUOTE,
            value: {
                text: "'후르츠 찜해놓은 상품에 있었던\n벨트는 now on my 허리.'",
                author: 'FaSHioN 가사 중',
            },
        },
        {
            id: 'spotify-embed',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SPOTIFY_EMBED,
        },
        {
            id: 'main-intro-content',
            type: COLLECTION_ITEM_TYPES.COLLECTION_INTRO_CONTENT,
        },
    ];

    const member1 = [
        {
            id: 'member1-section-title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SECTION_TITLE,
            value: {title: '마틴'},
        },
        {
            id: 'member1-image-caption',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBER_MARTIN,
                aspectRatio: 361 / 451.25,
                caption: 'Credit: BIGHIT MUSIC',
            },
        },
        {
            id: 'member1-qna-1',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '본인 취향이나 스타일을 한 줄로 소개해주세요.',
                answer: '절제되고 과하지 않으면서 귀여운 포인트가 있는 느낌이에요.',
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-qna-2',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '스타일에 관한 영감은 어디서 주로 받는 편인가요?',
                answer: '자유로우면서도 귀여운 포인트나 빈티지하면서도 무게감이 있는 스타일을 좋아해서, 사복으로 한정하면 아론 폴, 더 거슬러 올라가면 커트 코베인에서 영감을 많이 받아요. 또 좋아하는 파파라치 샷을 보면서 그 사진 속 인물에 대해 연구하고, 시기에 따라서 한 인물을 정해두고 많은 영향을 받아 옷을 입고 또 사고 있어요.',
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-qna-3',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '아이코닉한 인물에게서 주로 영감을 받으시는 것 같아요. 혹시 좋아하는 브랜드나 디자이너도 그러한 편인가요?',
                answer: '네 맞아요. 앤트워프 식스의 앤 드뮐미스터가 지금 가장 먼저 생각나요. 또 리카르도 티시가 지방시에서 일할 때의 컬렉션과 제가 태어나기 전, 크리스토퍼 데카닌의 2006~2011년 발망 컬렉션도 굉장히 좋아해요. 이 시기 제품을 후루츠에서 사면 빈티지하고 사용감이 묻어나서 더 예쁜 것 같아요. 번외로 요즘 브랜드 중에는 커마웨어에 눈길이 가고 있어요. 절제되면서도 아방가르드한 느낌과 아우터들이 특히 과하지 않으면서 포인트가 되는 것 같아요.',
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-qna-4',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '패션에 대한 내공이 상당하신데 저희 앱에 팔로우하고 있는 디자이너도 많을 것 같아요.',
                answer: '크리스 반 아쉐, 피에르 하디, 이자벨 마랑, 필립 플레인, 라프 시몬스, 메종 마르지엘라 신발 카테고리 알람 설정 해놓고 제 사이즈 무한 대기 중입니다...',
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-qna-5',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '가장 최근 구매한 아이템이나 위시리스트 아이템.',
                answer: "최근 스터드를 구매해서 신발 하나에 '몰빵'하고 있어요. (웃음) 그리고 릭오웬스의 지오바스켓, 라몬즈 스니커즈는 꼭 살 거예요.",
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-qna-6',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: "벌써 다른 아티스트의 곡에 여러 번 참여하셨어요. 아일릿의 <Magnetic>, 투모로우바이투게더의 <Deja vu> 등등에요. 코르티스에서는 리더로도 활동하고 있어요. 음악 외에 스타일 디렉팅에도 많이 참여할 것 같은데.",
                answer: "중요한 콘셉트를 잡을 때는 레이블의 스태프분들과 서로 상의를 많이 해요. 먼저 스태프 분들께서 우리의 평소 모습을 관찰해 큰 방향을 제시해 주시고, 우리 의견을 더하고 빼며 발전시켜 나가요. 물론 특별한 경우에는 저희 의견을 먼저 듣고 나서 그것을 디벨롭할 때도 있기도 해요. ‘FaSHioN’ 활동 기간 동안 재밌는 시도도 스페셜하게 해볼 예정이니 많은 기대 부탁드릴게요!",
                answerPrefix: '마틴',
            },
        },
        {
            id: 'member1-wishlist',
            type: COLLECTION_ITEM_TYPES.COLLECTION_WISHLIST,
            value: {name: '마틴', userId: 1418107},
        },
    ];

    const member2 = [
        {
            id: 'member2-section-title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SECTION_TITLE,
            value: {title: '제임스'},
        },
        {
            id: 'member2-image-caption',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBER_JAMES,
                aspectRatio: 361 / 451.5,
                caption: 'Credit: BIGHIT MUSIC',
            },
        },
        {
            id: 'member2-qna-1',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '본인 취향이나 스타일을 한 줄로 소개해주세요.',
                answer: '지갑이 아프지 않은 선에서 제 마음대로 하는 것을 좋아해요.',
                answerPrefix: '제임스',
            },
        },
        {
            id: 'member2-qna-2',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '요즘 가장 눈여겨보는 취향이나 스타일 그리고 즐겨입는 아이템.',
                answer: '저는 액세서리, 특히 일상에서도 팔찌, 귀걸이는 무조건 챙기는 편이에요. 그리고 Hats, Caps, Beanies 4 Life.',
                answerPrefix: '제임스',
            },
        },
        {
            id: 'member2-qna-3',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '일반적으로 자신의 패션은 자신이 가장 좋아하는 브랜드에서 찾곤 하잖아요.',
                answer: '가장 좋아하는 브랜드로는 비비안 웨스트우드, 폴로 랄프로렌을 꼽고 싶어요. 하지만 제 스타일은 제 감을 믿어요. 요즘은 미디어를 통해 자연스럽게 습득할 수 있는 정보가 많기도 하고, 후루츠에서 For You도 많이 보고 셔플도 자주 하면서 다양한 브랜드를 접하려고 해요.',
                answerPrefix: '제임스',
            },
        },
        {
            id: 'member2-qna-4',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '그렇다면 요즘 앱에서 가장 많이보고 있는 카테고리나 제품이 있다면.',
                answer: '이제 곧 가을이고 추워질 테니까 미리 아우터류를 찾아보고 있어요. 디젤 벨트랑 CNCV 팬츠도 위시리스트에 넣어놨어요.',
                answerPrefix: '제임스',
            },
        },
        {
            id: 'member2-qna-5',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '그렇다면 혹시 이런 귀여운(?) 부분도 궁금해하는 팬분들이 꽤 있을 것 같아요. 구매하기 전에 네고 요청을 하는지, 아니면 쿨하게 결제를 하는지.',
                answer: '네고는 할 수 있으면 무조건 합니다!',
                answerPrefix: '제임스',
            },
        },
        {
            id: 'member2-wishlist',
            type: COLLECTION_ITEM_TYPES.COLLECTION_WISHLIST,
            value: {name: '제임스', userId: 1418100},
        },
    ];

    const member3 = [
        {
            id: 'member3-section-title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SECTION_TITLE,
            value: {title: '주훈'},
        },
        {
            id: 'member3-image-caption',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBER_JUHOON,
                aspectRatio: 361 / 451.22,
                caption: 'Credit: BIGHIT MUSIC',
            },
        },
        {
            id: 'member3-qna-1',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '주훈님은 벌써 에디 슬리먼을 좋아하는 아티스트로 여러 매체의 인스타 피드를 장식한 것 같아요.',
                answer: '벌써 제 취향을 많은 분들께서 알아주셔서 감사할 따름이에요. 저는 에디 슬리먼 느낌을 베이스로 한 스키니진, 하얀 민소매, 그리고 부츠 등등의 스타일을 선호해요.',
                answerPrefix: '주훈',
            },
        },
        {
            id: 'member3-qna-2',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '취향이 정말 확고하신데 보통 어디서 영감을 받으시나요?',
                answer: '보통 인스타그램 아카이브 계정들의 피드를 보거나, 핀터레스트에서 입고 싶은 스타일들을 많이 찾아보고 실제로 후루츠에서도 많이 참고를 하는 편이에요. 생로랑 팬츠, 지방시 슈즈, 디올 옴므 티셔츠 등등 너무 많아서 지금 위시리스트가 꽉 찼어요. 요즘은 발망처럼 부츠 안에 바지를 넣는 게 예쁜 것 같아서 부츠류를 많이 찾아보고 있어요.',
                answerPrefix: '주훈',
            },
        },
        {
            id: 'member3-qna-3',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '패션에 대한 이해도가 리더인 마틴님과 견줄 수 있을 것 같아요. 저희 앱에선 보통 어떤 방식으로 디깅하고 계신가요.',
                answer: '일단 처음에는 사이즈나 가격 상관없이 좋은 느낌을 주는 옷들을 찾아봐요. 그리고 마음에 드는 상품이 있으면 연관된 상품들 뜨는 걸 눌러보고 그 판매자가 파는 다른 상품들도 둘러보다가 느낌, 가격, 사이즈가 모두 맞아떨어지는 상품을 찾으면 그때 구매하고 있어요.',
                answerPrefix: '주훈',
            },
        },
        {
            id: 'member3-qna-4',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: "팀 비하인드 영상과 자체 제작 컨텐츠, '자컨'에서 모든 멤버들의 '새깅(Sagging)'이 돋보이던데, 저는 그중에서도 주훈님과 성현님의 바지가 멤버들보다 더 새깅이 되어있어서 유난히 인상 깊더라구요.",
                answer: '저는 지금 이 팀에 합류하기 전엔 새깅을 전혀 하지 않았어요. 팀에 합류하고 저희 멤버들이 새깅하는 모습을 보고 너무 멋있어서 시작하게 되었어요.',
                answerPrefix: '주훈',
            },
        },
        {
            id: 'member3-wishlist',
            type: COLLECTION_ITEM_TYPES.COLLECTION_WISHLIST,
            value: {name: '주훈', userId: 1418113},
        },
    ];

    const member4 = [
        {
            id: 'member4-section-title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SECTION_TITLE,
            value: {title: '성현'},
        },
        {
            id: 'member4-image-caption',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBER_SEONGHYEON,
                aspectRatio: 361 / 481.18,
                caption: 'Credit: BIGHIT MUSIC',
            },
        },
        {
            id: 'member4-qna-1',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '본인의 스타일을 한 줄로 소개해주세요.',
                answer: "요즘 인디 슬리즈(Indie Sleaze) 매력에 빠져있는 것 같아요.\n\n❉ 인디 슬리즈란? : 1980년대 패션과 그런지 스타일에 영향을 받은 반항적이고 몽환적인 패션. 그러나 예전처럼 자유분방함만을 강조하기 보단 일부만 차용해 빈티지스럽고 보다 세련되게 변형되었다.",
                answerPrefix: '성현',
            },
        },
        {
            id: 'member4-qna-2',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '요즘 즐겨 입는 아이템이랑 구매를 망설이고 있는 아이템.',
                answer: '웨스턴 부츠와 플레어 진을 즐겨 입어요. 벨트도 조만간 하나 살 예정이에요. 아 그리고 디지털카메라도 눈여겨보고 있어요.',
                answerPrefix: '성현',
            },
        },
        {
            id: 'member4-qna-3',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '피트 도허티(Pete Doherty)라는 인물은 저도 처음 들어보는데, 이분의 스타일을 많이 참고한다고 말씀해주셨어요.',
                answer: '피트 도허티라는 영국 록 가수의 스타일을 좋아해요. 디자이너는 아니지만 패션계에선 아이코닉한 인물인데, 에디 슬리먼의 뮤즈라고 들었어요. 이분의 과거 스타일을 많이 참고하고 있습니다.',
                answerPrefix: '성현',
            },
        },
        {
            id: 'member4-qna-4',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '자컨에서 건호님의 옷을 입는 장면이 나왔어요. 아무래도 합숙 생활을 하면 옷이 섞일 때가 종종 있을 것 같아요. 혹시 그럴 때마다 어떻게 해결하는지.',
                answer: '멤버들이 다들 옷을 좋아하다 보니 예전엔 옷이 겹치기도 하고 섞이기도 해서 옷을 빌려 입기도 했는데 지금은 잘 빌려 입지 않는 것 같아요. 웬만하면 겹치는 옷은 안 입으려고 해요.',
                answerPrefix: '성현',
            },
        },
        {
            id: 'member4-wishlist',
            type: COLLECTION_ITEM_TYPES.COLLECTION_WISHLIST,
            value: {name: '성현', userId: 1418115},
        },
    ];

    const member5 = [
        {
            id: 'member5-section-title',
            type: COLLECTION_ITEM_TYPES.COLLECTION_SECTION_TITLE,
            value: {title: '건호'},
        },
        {
            id: 'member5-image-caption',
            type: COLLECTION_ITEM_TYPES.COLLECTION_IMAGE_CAPTION,
            value: {
                url: IMAGE_CORTIS_MEMBER_KEONHO,
                aspectRatio: 361 / 451.25,
                caption: 'Credit: BIGHIT MUSIC',
            },
        },
        {
            id: 'member5-qna-1',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '본인 취향/스타일 한 줄 소개',
                answer: '클래식하면서도 거친 느낌입니다.',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-2',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '요즘 즐겨 입는 아이템/핏',
                answer: '슬림한 부츠컷 팬츠를 좋아해요.',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-3',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '스타일에 관한 영감은 어디서 주로 받는 편인가요?',
                answer: '제가 듣는 음악인 것 같아요. 어떤 날에는 클래식한 음악을 듣기도 하고, 거친 음악을 듣기도 하고, 또 너무 거칠지 않은 음악도 듣는데요. 제가 추구하는 스타일도 비슷하게 클래식하기도, 거칠기도, 또 너무 거칠지 않기도 해요.',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-4',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '그렇다면 지금 가장 마음에 드는 브랜드나 디자이너가 있다면요?',
                answer: '역시 고르기 어려운데, 지금 당장은 히스테릭 글래머나 비비안 웨스트우드를 꼽고 싶어요. 실제로 후루츠에서도 지금 이 두 브랜드를 가장 많이 찾아보고 있어요. 또 현재 아트 디렉터이자 디자이너로 활동 중인 마크 칼먼의 스타일을 무척 좋아해요. 스타일링을 심플하게 하는 것 같으면서도 아무나 따라 할 수 없는 그만의 매력이 느껴지니까요.',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-5',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '혹시 눈여겨보고 있는 제품이 있다면.',
                answer: 'JW ANDERSON과 Wellipets라는 영국 브랜드가 콜라보한 개구리 클로그를 사고 싶은데 23FW 제품이라 판매하지 않아서 후루츠를 틈틈이 찾아보고 있어요. 또 뮬을 사고 싶어서 꼼데가르송 옴므 뮬을 봐두었는데 이미 판매가 돼 다른 뮬을 찾아보고 있기도 해요.',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-6',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: "데뷔 EP <COLOR OUTSIDE THE LINES> 3번 트랙 ‘FaSHioN’ 가사에 ‘후루츠’가 등장해요. 이미 수차례 설명하셨겠지만, 그래도 저희한테는 무척 뜻깊은 가사이기에 안 물어볼 수가 없었어요.",
                answer: "가사가 엄청 즉흥적으로 나왔던 상황이었어요. 가사를 쓰기 며칠 전 후루츠에서 벨트를 샀었거든요. 그 벨트를 착용하고 멤버들이랑 같이 작사하고 있었는데 라임이 마침 ‘허리’로 나와서 자연스럽게 벨트 이야기로 이어졌던 것 같아요. 저희 팬분들도 재밌다고 하셔서 정말 다행이에요.",
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-qna-7',
            type: COLLECTION_ITEM_TYPES.COLLECTION_QNA,
            value: {
                question: '건호님한테 특별히 여쭤보고 싶은 질문이 있어요. 후루츠에게 바라는 점 하나만 말씀해 주세요.',
                answer: '찜한 아이템과 비슷한 무드의 아이템이 추천으로 나왔으면 좋겠어요. 그래도 지금 너무 잘 쓰고 있습니다!',
                answerPrefix: '건호',
            },
        },
        {
            id: 'member5-wishlist',
            type: COLLECTION_ITEM_TYPES.COLLECTION_WISHLIST,
            value: {name: '건호', userId: 1418117},
        },
    ];

    return {header, member1, member2, member3, member4, member5};
}

export function getCollectionCortisData() {
    const {header, member1, member2, member3, member4, member5} = getCollectionCortisSections();
    return [
        ...header,
        ...member1,
        ...member2,
        ...member3,
        ...member4,
        ...member5,
    ];
}
